import { BaseRoutingFunction, ResourceRoutingFunction, NestedResourceRoutingFunction } from './types/Routes'

export const QUOTE_EDIT_PATH = '/quotes/details'

export const signInPath: BaseRoutingFunction = () => '/auth/sign-in'
export const resetPasswordPath: BaseRoutingFunction = () => '/auth/reset-password'
export const setPasswordPath: BaseRoutingFunction = () => '/auth/set-password'
export const acceptInvitationPath: BaseRoutingFunction = () => '/auth/accept'

export const rootPath: BaseRoutingFunction = () => '/'
export const dashboardPath: BaseRoutingFunction = () => '/'
export const dashboardNamedPath: BaseRoutingFunction = () => '/dashboard'

export const quotesPath: BaseRoutingFunction = () => '/quotes'
export const quotesShowPath: ResourceRoutingFunction = (id) => (id ? `/quotes/${id}` : '/quotes/:id')
export const quotesCommentsPath: ResourceRoutingFunction = (id) =>
  id ? `/quotes/${id}/comments` : '/quotes/:id/comments'
export const quotesUpdateExpiresAtPath: ResourceRoutingFunction = (id) =>
  id ? `/quotes/${id}/update-expires-at` : '/quotes/:id/update-expires-at'
export const quotesNewPath: BaseRoutingFunction = () => '/quotes/new'
export const quotesBuildPath: BaseRoutingFunction = () => '/quotes/build'
export const quotesEditPath: ResourceRoutingFunction = (id) => (id ? `/quotes/${id}/edit` : '/quotes/:id/edit')
export const quotesFinalizePath: ResourceRoutingFunction = (id) =>
  id ? `/quotes/${id}/finalize` : '/quotes/:id/finalize'
export const quotesFinalizeAndPayPath: ResourceRoutingFunction = (id) =>
  id ? `/quotes/${id}/finalize/payment` : '/quotes/:id/finalize/payment'
export const quotesEditPricingPath: ResourceRoutingFunction = (id) =>
  id ? `/quotes/${id}/pricing` : '/quotes/:id/pricing'
export const quotesEditParametersPath: ResourceRoutingFunction = (id) =>
  id ? `/quotes/${id}/parameters` : '/quotes/:id/parameters'
export const quotesDetailsPath: ResourceRoutingFunction = (id) => (id ? `/quotes/${id}/details` : '/quotes/:id/details')
export const quoteDetailsPremiumDetailsPath: ResourceRoutingFunction = (id) =>
  id ? `/quotes/${id}/details/premium-details` : '/quotes/:id/details/premium-details'
export const quotePremiumDetailsPath: ResourceRoutingFunction = (id) =>
  id ? `/quotes/${id}/premium-details` : '/quotes/:id/premium-details'
export const quotesClaimsHistoryPath: ResourceRoutingFunction = (id) =>
  id ? `/quotes/${id}/claims-history` : '/quotes/:id/claims-history'
export const quotesDetailsCommentsPath: ResourceRoutingFunction = (id) =>
  id ? `/quotes/${id}/details/comments` : '/quotes/:id/details/comments'
export const quotesPayAndBindPath: ResourceRoutingFunction = (id) =>
  id ? `/quotes/${id}/payment` : '/quotes/:id/payment'
export const quotesAuthorizationSubmitted: BaseRoutingFunction = () => '/quotes/authorization_submitted'

export const offlineClaimEventsPath: BaseRoutingFunction = () => '/offline/claim_events'
export const offlineClaimEventsShowPath: ResourceRoutingFunction = (id) =>
  id ? `/offline/claim_events/${id}` : '/offline/claim_events/:id'

export const policyEventsPath: BaseRoutingFunction = () => '/policy-events'
export const policyEventsEditPath: ResourceRoutingFunction = (id) =>
  id ? `/policy-events/${id}/edit` : '/policy-events/:id/edit'

export const policyContainersPath: BaseRoutingFunction = () => '/policies'
export const policyContainersShowPath: ResourceRoutingFunction = (id) => (id ? `/policies/${id}` : '/policies/:id')
export const policyContainersCommentsPath: ResourceRoutingFunction = (id) =>
  id ? `/policies/${id}/comments` : '/policies/:id/comments'
export const policyContainersShowPolicyEventsPath: ResourceRoutingFunction = (id) =>
  id ? `/policies/${id}/events` : '/policies/:id/events'
export const policyContainersShowPolicyEventsShowPath: NestedResourceRoutingFunction = (id, eventId) =>
  id && eventId ? `/policies/${id}/events/${eventId}` : '/policies/:id/events/:eventId'
export const policyContainersShowPolicyEventsShowPremiumDetailsPath: NestedResourceRoutingFunction = (id, eventId) =>
  id && eventId ? `/policies/${id}/events/${eventId}/premium-details` : '/policies/:id/events/:eventId/premium-details'
export const policyContainersCreateCancellationQuotePath: ResourceRoutingFunction = (id) =>
  id ? `/policies/${id}/cancel` : '/policies/:id/cancel'
export const policyContainersCreateEndorsementQuotePath: ResourceRoutingFunction = (id) =>
  id ? `/policies/${id}/endorsement` : '/policies/:id/endorsement'
export const policyContainersChangeRenewabilityPath: ResourceRoutingFunction = (id) =>
  id ? `/policies/${id}/change-renewability` : '/policies/:id/change-renewability'
export const policyContainersCreateRenewalQuotePath: ResourceRoutingFunction = (id) =>
  id ? `/policies/${id}/create-renewal-quote` : '/policies/:id/create-renewal-quote'

export const paymentsPath: BaseRoutingFunction = () => '/payments'
export const commissionsPath: BaseRoutingFunction = () => '/commissions'
export const reportsPath: BaseRoutingFunction = () => '/reports'
export const settingsPath: BaseRoutingFunction = () => '/settings'
export const createQuotePath: BaseRoutingFunction = () => '/create-quote'
export const supportPath: BaseRoutingFunction = () => 'http://help.poweredbyagile.com.au/support/home'
export const changePassword: BaseRoutingFunction = () => '/current-user/change-password'
export const productsPath: BaseRoutingFunction = () => '/products'

export const renewalsPath: BaseRoutingFunction = () => '/renewals'
export const proposalsPath: BaseRoutingFunction = () => '/proposals'
export const requireAuthorizationPath: BaseRoutingFunction = () => '/require-authorization'
export const cancellationQuotesPath: BaseRoutingFunction = () => '/cancellation-quotes'
export const endorsementQuotesPath: BaseRoutingFunction = () => '/endorsement-quotes'

export const partnersPath: BaseRoutingFunction = () => '/partners'
export const newPartnerPath: BaseRoutingFunction = () => '/partners/new'
export const showPartnerPath: ResourceRoutingFunction = (id) => (id ? `/partners/${id}` : '/partners/:id')
export const editPartnerPath: ResourceRoutingFunction = (id) => (id ? `/partners/${id}/edit` : '/partners/:id/edit')
export const logoPartnerPath: ResourceRoutingFunction = (id) => (id ? `/partners/${id}/logo` : '/partners/:id/logo')
export const showPartnerPreferencesPath: ResourceRoutingFunction = (id) =>
  id ? `/partners/${id}/settings` : '/partners/:id/settings'

export const newPartnerUserPath: ResourceRoutingFunction = (partnerId) =>
  partnerId ? `/partners/${partnerId}/users/new` : '/partners/:partnerId/users/new'

export const showPartnerUserPath: NestedResourceRoutingFunction = (partnerId, id) =>
  partnerId && id ? `/partners/${partnerId}/users/${id}` : '/partners/:partnerId/users/:id'
export const editPartnerUserPath: NestedResourceRoutingFunction = (partnerId, id) =>
  partnerId && id ? `/partners/${partnerId}/users/${id}/edit` : '/partners/:partnerId/users/:id/edit'

export const clientsPath: BaseRoutingFunction = () => '/clients'
export const newClientPath: BaseRoutingFunction = () => '/clients/new'
export const showClientPath: ResourceRoutingFunction = (id) => (id ? `/clients/${id}` : '/clients/:id')
export const editClientPath: ResourceRoutingFunction = (id) => (id ? `/clients/${id}/edit` : '/clients/:id/edit')

export const newClientUserPath: ResourceRoutingFunction = (partnerId) =>
  partnerId ? `/clients/${partnerId}/users/new` : '/clients/:clientId/users/new'

export const showClientUserPath: NestedResourceRoutingFunction = (partnerId, id) =>
  partnerId && id ? `/clients/${partnerId}/users/${id}` : '/clients/:clientId/users/:id'
export const editClientUserPath: NestedResourceRoutingFunction = (partnerId, id) =>
  partnerId && id ? `/clients/${partnerId}/users/${id}/edit` : '/clients/:clientId/users/:id/edit'

export const howToClaimPath: BaseRoutingFunction = () => '/how-to-claim'
export const policyClausesPath: BaseRoutingFunction = () => '/policy-clauses'
export const showPolicyClausePath: ResourceRoutingFunction = (id) =>
  id ? `/policy-clauses/${id}` : '/policy-clauses/:id'
export const newPolicyClausePath: BaseRoutingFunction = () => `/policy-clauses/new`
export const editPolicyClausePath: ResourceRoutingFunction = (id) =>
  id ? `/policy-clauses/${id}/edit` : '/policy-clauses/:id/edit'
export const tasksPath: BaseRoutingFunction = () => '/tasks'
export const tasksShowPath: ResourceRoutingFunction = (id) => (id ? `/tasks/${id}` : '/tasks/:id')
